import Vue from 'vue';
import Url from "../helpers/Url";

export default {
  install(Vue, routes) {
    Vue.prototype.route = function(routeName, routeVars) {
      if (
        !_.isObject(routes) ||
        _.isEmpty(routes) ||
        !_.has(routes, routeName)
      ) {
        return "#";
      }

      var url = routes[routeName];

      // apply any route parameter bindings provided
      if (_.isObject(routeVars) && !_.isEmpty(routeVars)) {
        _.each(routeVars, (v, k) => {
          url = url.replace(new RegExp(`{${k}\??}`, "g"), v);
        });
      }

      // remove any optional route parameters without bindings
      url = url.replace(new RegExp(/\{\w+\?\}/, "g"), "");

      // look for any required route parameters missing bindings
      var matches = url.match(new RegExp(/\{\w+\}/, "g"));
      if (!!matches && matches.length > 0) {
        matches.forEach((match) => {
          match = match.replace(/[\{\}\?]/g, "");
          console.error(
            `Missing binding for required route parameter: ${match}`
          );
        });
        return "#";
      }

      // trim double slashes and slashes from the beginning and end of the path
      url = url
        .replace(/^\/+/, "")
        .replace(/\/+$/, "")
        .replace("//", "/");

      // console.log(`${Url.base}/${url}/`);
      return `${Url.base}/${url}/`;
    };

    Vue.prototype.isRoute = function(routeName, routeVars) {
      return Vue.prototype
        .route(routeName, routeVars)
        .includes(window.location.pathname);
    };

    Vue.prototype.goToRoute = function(route, params, newWindow = false) {
      var url = Vue.prototype.route(route, params);
      if (newWindow) {
        window.open(url, "_blank");
      } else {
        window.location = url;
      }
    };

    Vue.prototype.goToUrl = function(url, newWindow = false) {
      if (newWindow) {
        window.open(url, "_blank");
      } else {
        window.location = url;
      }
    };
  },
};
